module.exports = __webpack_public_path__ + "static/media/BadgeTemplates-19.9d597bef.svg";